<template>
    <div>
        <h1>Pontos</h1>
    </div>
</template>
    
<script>

export default {
    name: 'pontos',
    components: {
        
    },
    data() {
        return {
            
        }
    },
    methods: {
       
    }
}
</script>
    